// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e2-3";
export var flatBottomCorners = "_e2-5";
export var productImage = "_e2-0";
export var quantityContainer = "_e2-2";
export var quantityHeader = "_e2-6";
export var tooltip = "_e2-1";
export var wrapAndEllipsesOverflow = "_e2-4";